import { Lock } from "lucide-react";
import { Link } from "react-router-dom";
import { Path } from "../../types/routes";
import styles from "./footer.module.css";

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.inner}>
      <span className={styles.brand}>Signi · Learn sign language with your camera</span>
      <span className={styles.note}>
        <Lock size={14} aria-hidden="true" /> Video is processed in your browser and never uploaded.
      </span>
      <Link to={Path.About} className={`${styles.link} tap-target`}>
        About Signi
      </Link>
    </div>
  </footer>
);

export default Footer;
